<template>
  <div class="renew3_payment">
    <div class="how2">
      <div class="yagiprime_check" v-if="is_simultaneous">
        <div class="check_block">
          <label for="yagiprime_checkbox">
            <input
              type="checkbox"
              id="yagiprime_checkbox"
            />ヤギプライムに加入して<span class="red_color">使い放題</span>
          </label>
          <p class="t_amount">月額 550円(税込)</p>
        </div>

        <p class="t_terms">
          <img
            src="/static/renew3_img/carat_img/caratcheck_icon.svg"
            alt="チェック"
            class="check_icon"
          />
          <a href="/yagiprimeterms" target="_blank">ヤギプライム利用規約</a
          >に同意する
        </p>
      </div>

      <div class="payment_common">
        <ul class="payment_list">
          <li class="payment_item">
            <div class="p_title">
              <input
                type="radio"
                id="how_payment1"
                name="how_payment"
                value="card"
                v-model="selectedPaymentMethod"
              />
              <label
                :class="{ 'selected-label': selectedPaymentMethod === 'card' }"
                for="how_payment1"
                >クレジットカードで支払う</label
              >
            </div>
            <div class="p_contents" v-if="selectedPaymentMethod === 'card'">
              <div class="card_form">
                <CardPayment
                  ref="cardPayment"
                  @payment-success="handlePaymentSuccess"
                  @payment-error="handlePaymentError"
                  :onValidationChange="handleValidationChange"
                  :isSubscription="is_subscription"
                  :amount="price"
                  :selectedIndex="selectedIndex"
                  :notificationSetting="notificationSetting"
                />
              </div>
              <div class="memo">
                <p class="red_color">※お客様のカード情報は保存されません。</p>
                <p class="red_color">
                  ※Visa・MasterCard・American Express・JCB・Diners
                  Club・Discoverのクレジットカードがご利用可能です。
                </p>
              </div>
              <div class="payment-btn">
                <template v-if="!isAuthenticated">
                  <button class="payment-card-btn" @click="openLoginDialog">
                    ログインして続行
                  </button>
                </template>
                <template v-else>
                  <button
                    class="payment-card-btn"
                    :id="'yagiprime-payment-' + currentPathEnd"
                    :disabled="!isCardFormValid || isCardButtonDisabled"
                    @click="handleCardPayment"
                  >
                    クレジットカードで登録する
                  </button>
                </template>
              </div>
            </div>
          </li>

          <li class="payment_item">
            <div class="p_title">
              <input
                type="radio"
                id="how_payment2"
                name="how_payment"
                value="paypay"
                v-model="selectedPaymentMethod"
              />
              <label
                :class="{
                  'selected-label': selectedPaymentMethod === 'paypay'
                }"
                for="how_payment2"
                >PayPayで支払う</label
              >
            </div>
            <div class="p_contents" v-if="selectedPaymentMethod === 'paypay'">
              <div class="memo">
                <p class="red_color">
                  ※PayPayアプリでの連携後、自動で決済が行われます。決済成功後、マイページにて登録状態を確認できます。
                </p>
                <p class="red_color">
                  ※yagishに戻っても画面が変わらない場合はリロードしてみてください。
                </p>
              </div>
              <div class="payment-btn">
                <template v-if="!isAuthenticated">
                  <button class="payment-paypay-btn" @click="openLoginDialog">
                    ログインして続行
                  </button>
                </template>
                <template v-else>
                  <button
                    :id="'yagiprime-payment-' + currentPathEnd"
                    class="payment-paypay-btn"
                    @click="paypayPayment"
                  >
                    <img
                      src="/static/renew2_img/paypay_payment_lg.png"
                      class="paypay-btn-img"
                    />
                  </button>
                </template>
              </div>
            </div>
          </li>

          <li class="payment_item" v-if="isApplePayAvailable">
            <div class="p_title">
              <input
                type="radio"
                id="how_payment3"
                name="how_payment"
                value="applepay"
                v-model="selectedPaymentMethod"
              />
              <label
                :class="{
                  'selected-label': selectedPaymentMethod === 'applepay'
                }"
                for="how_payment3"
                >Apple Payで支払う</label
              >
            </div>
            <div class="p_contents" v-if="selectedPaymentMethod === 'applepay'">
              <div class="memo">
                <p class="red_color">
                  ※Apple Payでの支払いが選択されています。
                </p>
              </div>
              <div class="payment-btn">
                <template v-if="!isAuthenticated">
                  <button class="payment-applepay-btn" @click="openLoginDialog">
                    ログインして続行
                  </button>
                </template>
                <template v-else>
                  <!-- id は MyprofileEdit のレガシー経路が参照しているため残す -->
                  <div
                    v-if="isDisplayApplePayButton"
                    ref="expressCheckoutEl"
                    id="payment-request-button"
                  ></div>
                  <div v-else class="skeleton-loader">
                    <div class="skeleton skeleton-button"></div>
                  </div>
                </template>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="merit" v-if="is_subscription">
        <div class="yagiprime_note">
          <h3 class="yagiprime_note-h3">ヤギプライムに関する注意事項</h3>
          <ul class="yagiprime_note-list">
            <li class="yagiprime_note-item">
              <p class="item-left">販売価格</p>
              <p class="item-txt">
                30日間ごとに550円(税込)となります。通信等にかかる費用は別途お客様のご負担となります。
              </p>
            </li>
            <li class="yagiprime_note-item">
              <p class="item-left">支払い時期及びサービスの開始時期</p>
              <p class="item-txt">
                本サービスにお申込みいただき、お客様の登録が完了した時点でクレジットカードによりご利用代金が引き落とされると同時に、サービスが開始されます。初回のサービス提供期間終了後、自動更新され、お客様の選択により、以降30日間ごとに550円（税込）がかかります。利用代金は更新されたサービス期間の初日に登録されたクレジットカードまたはPayPayから引き落とされます。
              </p>
            </li>
            <li class="yagiprime_note-item">
              <p class="item-left">支払方法</p>
              <p class="item-txt">
                クレジットカード（Visa・MasterCard・American
                Express・JCB・Diners Club・Discover）をご利用いただけます。
              </p>
              <p class="item-txt">PayPayをご利用いただけます。</p>
            </li>
            <li class="yagiprime_note-item">
              <p class="item-left">契約の申し込みの撤回又は解除</p>
              <p class="item-txt">
                お申込み手続きの完了後に、代金の返金やキャンセルはできません。※解約はマイページの「アカウント情報」からお申込みいただけます。
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * ヤギプライム等の決済方法セレクタ。Gate A: mitt / useAuth / axios。
 */
import axios from 'axios'
import { computed, getCurrentInstance, onMounted, ref, toRef, watch } from 'vue'
import VueCookies from 'vue-cookies'
import CardPayment from './CardPayment.vue'
import { useApplePayCheckout } from '@/composables/payment/useApplePayCheckout'
import { useAuth } from '@/composables/useAuth'
import { emitter, emitOpenLoginDialog } from '@/plugins/emitter'
import { isPrivateRelayEmail } from '@/utils/payment/isPrivateRelayEmail'

const PAYMENT_YAGIPRIME_RESULT = 'payment_yagiprime_result'
const SHOW_PRIVATE_RELAY_WARNING = 'show-private-relay-warning'

const props = defineProps({
  is_simultaneous: { type: Boolean, default: false },
  serviceName: { type: String, default: 'メール便' },
  price: { type: Number, default: 330 },
  is_subscription: { type: Boolean, default: false },
  selectedIndex: { type: Number, default: 1 },
  notificationSetting: { type: String, default: 'on' }
})

const emit = defineEmits<{
  (e: 'paypay-payment'): void
}>()

type HostVm = {
  $deviceLib: { isMobileDevice: boolean }
  $site: { appFlag: string }
  $varuna: { endPoints: Record<string, string> }
  $message: (opts: Record<string, unknown>) => void
}

type CardPaymentExpose = { createToken: () => void }

const vm = getCurrentInstance()!.proxy as unknown as HostVm
const { isAuthenticated, user, getClient } = useAuth()

const selectedPaymentMethod = ref('card')
const publishableKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY || ''
const isCardFormValid = ref(false)
const isCardButtonDisabled = ref(false)
const cardPayment = ref<CardPaymentExpose | null>(null)

const currentPathEnd = computed(() => {
  const pathParts = window.location.pathname.split('/').filter(Boolean)
  return pathParts.length > 0 ? pathParts[pathParts.length - 1] : ''
})

function currentUid(): string {
  return getClient()?.user?.uid ?? user.value?.uid ?? ''
}

function currentEmail(): string | undefined {
  return getClient()?.user?.email ?? user.value?.email ?? undefined
}

function openLoginDialog() {
  emitOpenLoginDialog()
}

function handlePaymentSuccess(_paymentData: unknown) {
  isCardButtonDisabled.value = false
  emitter.emit(PAYMENT_YAGIPRIME_RESULT, 'success')
  vm.$message({
    message: '決済が完了しました。',
    type: 'success'
  })
}

function handlePaymentError(error: { message?: string } | null) {
  console.error('支払いエラー:', error)
  let errorMessage = '支払いに失敗しました。'
  if (error && error.message) {
    errorMessage = error.message
  }
  vm.$message({
    message: errorMessage,
    type: 'error'
  })
  isCardButtonDisabled.value = false
}

function handleValidationChange(isValid: boolean) {
  isCardFormValid.value = isValid
}

const expressCheckoutEl = ref<HTMLElement | null>(null)

const {
  isApplePayAvailable,
  isDisplayApplePayButton,
  initializeExpressCheckout,
  applePayMount,
  hideApplePayButton
} = useApplePayCheckout({
  publishableKey,
  price: toRef(props, 'price'),
  serviceName: toRef(props, 'serviceName'),
  isSubscription: toRef(props, 'is_subscription'),
  notificationSetting: toRef(props, 'notificationSetting'),
  expressCheckoutEl
})

function handleCardPayment() {
  if (isPrivateRelayEmail(currentEmail())) {
    emitter.emit(SHOW_PRIVATE_RELAY_WARNING, () => {
      executeCardPayment()
    })
    return
  }
  executeCardPayment()
}

function executeCardPayment() {
  isCardButtonDisabled.value = true
  if (selectedPaymentMethod.value === 'card' && isCardFormValid.value) {
    cardPayment.value?.createToken()
  } else {
    alert('カード情報が無効です')
  }
}

function paypayPayment() {
  if (isPrivateRelayEmail(currentEmail())) {
    emitter.emit(SHOW_PRIVATE_RELAY_WARNING, () => {
      executePaypayPayment()
    })
    return
  }
  executePaypayPayment()
}

function executePaypayPayment() {
  if (props.is_subscription) {
    yagiprimePaypay().catch(() => {})
  } else {
    emit('paypay-payment')
  }
}

async function yagiprimePaypay() {
  emitter.emit('loading_on')

  const formData = new FormData()
  formData.append('uuid', currentUid())
  formData.append('subscription_type', String(props.selectedIndex))
  formData.append('notification_setting', props.notificationSetting)
  const routeId = (VueCookies as any).get('_YAGISH_YAGIPRIME_ROUTE_ID')
  formData.append('route', routeId || '')
  formData.append('app_flag', vm.$site.appFlag)
  formData.append('device_flg', vm.$deviceLib.isMobileDevice ? 'SP' : 'PC')
  formData.append('version', '3')
  formData.append('site_flag', 'r')
  formData.append('redirect_url', window.location.href)
  try {
    const response = await axios.post(
      vm.$varuna.endPoints.paypaySubscriptions,
      formData,
      { timeout: 60000 }
    )
    location.href = response.data.authorization_url
  } catch {
    vm.$message({
      message: '決済失敗しました',
      type: 'error'
    })
    emitter.emit(PAYMENT_YAGIPRIME_RESULT, 'error')
  } finally {
    emitter.emit('loading_off')
  }
}

watch(selectedPaymentMethod, (newVal) => {
  if (newVal === 'applepay') {
    applePayMount().catch(() => {})
  } else {
    hideApplePayButton()
  }
})

onMounted(async () => {
  if (props.is_subscription) {
    await initializeExpressCheckout()
  }
})
</script>

<style
  lang="scss"
  scoped
  src="@/assets/scss/payment/payment-method-selector.scss"
></style>
